 <template>
  <div id="app">
    <div class="app-info">
      <div class="app-info-back" >
        <div class="app-info-s">
          <div class="app-info-logo">
            <img src="../../assets/img/app-jisuanqi@2x.png" alt />
          </div>
          <div class="app-info-content">
            <span class="app-name">工具类-计算器APP</span>
            <br />
            <span class="app-desc">
              -伪装成计算器，人畜无害
              <br />-但消息推送过于频繁可能引起怀疑
            </span>
            <br />
            <button @click="jisuan();upclick(1)">立即下载使用</button>
          </div>
          <div class="app-info-right">免费</div>
      </div>
      <div class="app-cpm  app-cpm-button-60" >
            <span class="app-cpm-re">
            应用名称：计算器 应用版本： v2.1.1
              应用权限：查看权限<br/>  隐私权限：查看权限
              更新时间：2025年1月1日<br/>
              开发者:深圳市无间数码科技有限公司
            </span>
        </div>
      </div>
   

        <div class="app-info-back app-cpm-top-50" >
      <div class="app-info-s">
        <div class="app-info-logo">
          <img src="../../assets/img/app-zhixuan@2x.png" alt />
        </div>
        <div class="app-info-content">
          <span class="app-name">新闻类APP</span>
          <br />
          <span class="app-desc">
            -伪装成新闻类APP，神不知鬼不觉
            <br />-有新消息时推送新闻，完全仿真
            <br />-高可靠应用
          </span>
          <br />
          <button v-show="!btnflag" @click="toNews();upclick(2)">立即下载使用</button>
          <button v-show="btnflag" style="background: #ddd;color: #bbb;" disabled>敬请期待</button>
        </div>
        <div class="app-info-right">VIP专享</div>
      </div>

      <div class="app-cpm app-cpm-top-50" >
          <span class="app-cpm-re">
           应用名称：天下事 应用版本： v2.1.1
            应用权限：查看权限<br/>  隐私权限：查看权限
            更新时间：2025年1月1日<br/>
            开发者:深圳市无间数码科技有限公司
          </span>
      </div>
        </div>
            <div class="app-info-back app-cpm-top-50" >
      <div class="app-info-s">
        <div class="app-info-logo">
          <img src="../../assets/img/app-abc@2x.png" alt />
        </div>
        <div class="app-info-content">
          <span class="app-name">学习类-背单词APP</span>
          <br />
          <span class="app-desc">
            -伪装成背单词APP，学韩语等APP
            <br />-有新消息时推送单词考题
            <br />-积极向上的好学人设
          </span>
          <br />
          <button v-show="!btnflag" @click="shangxian();upclick(3)">即将上线</button>
          <button v-show="btnflag" style="background: #ddd;color: #bbb;" disabled>敬请期待</button>
        </div>
        <div class="app-info-right">VIP专享</div>
      </div>

      <div class="app-cpm app-cpm-top-50" >
          <span class="app-cpm-re">
           应用名称：学习乐 应用版本： v1.0.0
            应用权限：查看权限<br/>  隐私权限：查看权限
            更新时间：2025年1月1日<br/>
            开发者:深圳市无间数码科技有限公司
          </span>

      </div>
     </div>
            <!-- <div class="app-info-back app-cpm-top-50" >
      <div class="app-info-s">
        <div class="app-info-logo">
          <img src="../../assets/img/app-game@2x.png" alt />
        </div>
        <div class="app-info-content">
          <span class="app-name">游戏APP</span>
          <br />
          <span class="app-desc">
            -伪装成游戏APP
            <br />-有新消息时推送领金币
            <br />
-聊天时遇紧急情况，秒切至游戏页面
          </span>
          <button v-show="!btnflag" @click="shangxian();upclick(4)">即将上线</button>
          <button v-show="btnflag" style="background: #ddd;color: #bbb;" disabled>敬请期待</button>
        </div>
        <div class="app-info-right">VIP专享</div>
      </div>

      <div class="app-cpm" >
          <span class="app-cpm-re">
           应用名称：学习乐 应用版本： v1.0.0
            应用权限：查看权限<br/>  隐私权限：查看权限
            更新时间：2025年1月1日<br/>
            开发者:深圳市无间数码科技有限公司
          </span>

      </div>
            </div> -->
    </div>
  </div>
</template>
<script>
import tips from "@/estoast";
import util from "@/utils/util";
import store from "../../store/index";
import * as types from "../../store/types";
import { mapGetters } from "vuex";
import api from "../../api/index";

export default {
  name: "app",
  data() {
    return {
      msg: "注册协议",
      btnflag:false
    };
  },
  mounted(){
          console.log("cid:"+JSON.stringify(store.state.mutations.channel))

    //  if( store.state.mutations.channel == 'S00991'){
    //    this.btnflag = true
    //   }
  },
  methods: {
    upclick:function(tag){
      this.$point.eventtag(tag,"btn_100008");
    },
    jisuan: function() {
      
      this.$router.push("/userAppInfo?token=" + this.getToken);
    },
    jisuan: function() {
      this.$point.eventId("btn_100008");

      this.$router.push("/userAppInfo?token=" + this.getToken);
    },
     shangxian: function() {
      tips.toast("即将上线，敬请期待");
    },
    toNews: function() {
      
      if( store.state.mutations.channel == 'S00991'){
        tips.toast("即将上线，敬请期待");
        return
      }
      var userInfo = this.getUserInfo;
      if (userInfo.viptype > 0) {
        //判断是否过期
        var nowtime = new Date();
        var validitydate = new Date(userInfo.validitydate);
        if (validitydate < nowtime) {
          tips.toast("您的会员已经过期");
          return;
        } else {
          if (navigator.userAgent.indexOf("Android") > -1) {
              // tips.toast("即将上线，敬请期待");
              this.$point.eventId("down_app_news_100001");
                window.location =
              "http://wap.haoyunba.com/apk/news_android.apk";
            } else {
              this.$router.push("/userAppInfotxs?token=" + this.getToken);
            }
          
        }
      } else {
        if (navigator.userAgent.indexOf("Android") > -1) {
          // tips.toast("即将上线，敬请期待");
          this.$point.eventId("down_app_news_100001");
                window.location =
            "http://wap.haoyunba.com/apk/news_android.apk";
        } else {
          tips.toast("该软件付费后即可使用，请先购买会员");
          setTimeout(() => {
            this.$router.push("/pay");
          }, 2000);
        }
        return;
      }
     
    }
  },
  computed: {
    ...mapGetters([
      "getWxAlert",
      "loading",
      "getUserInfo",
      "getToken",
      "getUserList"
    ])
  }
};
</script>
<style  scoped>
#app {
  width: 100%;
  height: 1700px;
  overflow: hidden; /*超出部分隐藏*/
}
.app-info {
  width: 100%;
  height: auto;
}

.app-info-back {
  width: 690px;
  height: 370px;
  background: #0A0F3D;
  opacity: 1;
  border-radius: 20px;
  margin: 50px auto 50px auto;
  padding: 50px 0px;
}




.app-info-s {
  width: 632px;
  height: 275px;
  display: flex;
  margin: 0 auto;
     
}

.app-info-logo {
  width: 122px;
  height: 122px;
}

.app-info-logo img {
  width: 122px;
  height: 122px;
}

.app-info-content {
  flex: 1;
  text-align: left;
  padding: 0px 0px 0px 36px;
}

.app-name {
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 195, 167, 1);
  line-height: 50px;
}

.app-desc {
  width: 474px;
  height: 115px;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 195, 167, 0.5);
  line-height: 40px;
  overflow: hidden; /*超出部分隐藏*/
  white-space: nowrap; /*不换行*/
  text-overflow: ellipsis; /*超出部分文字以...显示*/
}

.app-cpm {
  width: 632px;
  height: 200px;
  display: flex;
  margin: 0 auto;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 195, 167, 0.5);
  line-height: 50px;
     
}
.app-cpm-top-50 {
   height: 420px;
  padding-bottom:50px;
}

.app-cpm-button-60{
   margin-top:-50px;
}

.app-cpm-re {

  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 195, 167, 0.5);
  line-height: 50px;
  overflow: hidden; /*超出部分隐藏*/
  white-space: nowrap; /*不换行*/
  text-overflow: ellipsis; /*超出部分文字以...显示*/
}

.app-info-content button {
  width: 210px;
  height: 48px;
  background: linear-gradient(90deg, #eeae91 0%, #f9dcc1 100%);
  border-radius: 24px;
  margin-top: 36px;
  border: none;
  font-size: 26px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(112, 44, 3, 1);
  line-height: 48px;
}

.app-info-right {
  width: 125px;
  height: 30px;
  background: url("../../assets/img/app-info-right@2x.png") no-repeat;
  background-size: 100% 100%;
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(127, 86, 47, 1);
  line-height: 30px;
  position: absolute;
  right: 68px;
}

.disb {
  background: #dddddd;
}
</style>
 
 
 


// WEBPACK FOOTER //
// src/components/common/downAppListtest.vue